import * as d3 from 'd3';

const closure = mainApp => {
    mainApp.setParams = function() {
        var svg = d3.select('#map-svg');

        mainApp.params = {
            width: +svg.attr('width') - 100, // width minus sum of l and r margins
            height: +svg.attr('height') - 0, // height minus sum of t and b margins

            margin: {
                left: 50,
                right: 50,
                top: 0,
                bottom: 0
            },

            yearScale: {
                domain: [1950, 2030],
                range: [0, +svg.attr('width') - 100 /* same as width */],
                ticks: 20
            },

            bubbleScale: {
                lowestVisible: 0,
                domain: [0, 50000], // population range (in thousands)
                range: [0, 40] // pixel range for bubbles
            },

            colorScale: {
                domain: [-50, -2, 0, 5, 75],
                range: ['#002E5F', '#002E5F', 'darkgray', '#E70033', '#E70033']
            },

            bubbleStroke: {
                normal: 0.5,
                hover: 2
            },

            msYear: 100 /*200*/
        };

        mainApp.params.scales = {};

        mainApp.params.scales.year = d3
            .scaleLinear()
            .domain(mainApp.params.yearScale.domain)
            .range(mainApp.params.yearScale.range)
            .clamp(true);

        mainApp.params.scales.bubble = d3
            .scaleSqrt()
            .domain(mainApp.params.bubbleScale.domain)
            .range(mainApp.params.bubbleScale.range)
            .clamp(true);

        mainApp.params.scales.color = d3
            .scaleLinear()
            .domain(mainApp.params.colorScale.domain)
            .range(mainApp.params.colorScale.range);

        mainApp.projection = d3
            .geoMercator()
            .scale(175)
            .translate([
                (mainApp.params.width + mainApp.params.margin.left + mainApp.params.margin.right) /
                    2 -
                    35,
                mainApp.params.height - 365
            ])
            .precision(0.1);

        mainApp.path = d3.geoPath().projection(mainApp.projection);
    };
};

export default closure;
